import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  ReactiveFormsModule,
  FormsModule,
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from "@angular/forms";
import {
  UserService,
  OperationsService,
  AuthenticationService,
  StorageService
} from "../../_services/index";
import {ToastrService} from 'ngx-toastr';
import { ProductsService } from "../../_services/products.service";

@Component({
  selector: "app-journalreports",
  templateUrl: "./journalreports.component.html",
  styleUrls: ["./journalreports.component.css"]
})
export class JournalreportsComponent implements OnInit {
  searchBy = '1';
  loan_id:any;
  people_id:any;
  active_loans:any;
  closed_loans:any;
  customers:any;
  investments:any;
  loan_product_id:any;

  public currentUser: any;
  public loading = false;
  public filter = {
    token: "",
    NEXT: "-1",
    prev: "",
    next: "",
    DDATE: "",
    DDATE_: "",
    START_DATE:'',
    END_DATE:'',
    SOURCE:''
  };
  public data: any;
  public start_date: any;
  public end_date: any;
  public total_debit: any;
  public total_credit: any;
  abgls:any;
  labgls:any;
  products:any;
  assets_balance_gl = '';
  newAccountForm: FormGroup;
  constructor(
    public fb: FormBuilder,
    public operationsService: OperationsService,
    public storageService: StorageService,
    private toastr: ToastrService,
    private productService:ProductsService
  ) {
    this.newAccountForm = new FormGroup({
          START_DATE: new FormControl(),
          END_DATE: new FormControl(),
          SOURCE: new FormControl()
    })
    this.currentUser = this.storageService.read<any>("currentUser");
    this.filter.token = this.currentUser.token;
    this.productService
    .getLoanProductsSlim(this.currentUser.token)
    .subscribe(companies => (this.products = companies));
  }

  ngOnInit() {
   // this.getJournalReports();
    
    this.getABGLS();
    this.getLABGLS();
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  getJournalReports() {
    this.operationsService
      .getJournalReports(this.currentUser.token, this.filter)
      .subscribe(data => {
        this.data = data;
        this.filter.NEXT = data.next;
      });
  }
  getABGLS(){ 
    this.operationsService
      .getABGLS(this.currentUser.token)
      .subscribe(res => {
      this.loading = false;
        this.abgls = res.data
      }, () => {
        this.loading = false;
        this.showError('An error occurred, try again');
      });
  }
  getLABGLS(){ 
    this.operationsService
      .getLABGLS(this.currentUser.token)
      .subscribe(res => {
      this.loading = false;
        this.labgls = res.data
      }, () => {
        this.loading = false;
        this.showError('An error occurred, try again');
      });
  }
  loadJournalReports() {
    const start_date = this.start_date;
    const end_date = this.end_date;
    const loan_id = this.loan_id;
    this.loading = true;
    this.operationsService
      .loadJournalReports(this.currentUser.token, start_date, end_date, loan_id, this.searchBy, this.people_id, this.loan_product_id)
      .subscribe(res => {
      this.loading = false;
        this.data = res.all;
        this.total_credit = res.total_credit;
        this.total_debit = res.total_debit;
        this.active_loans = res.activeloans;
        this.closed_loans = res.closedloans;
        this.investments = res.investments;
        this.customers = res.customers;
      }, () => {
        this.loading = false;
        this.showError('An error occurred, try again');
      });
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success');
  }
  saveABGL() {
    const start_date = this.start_date;
    const end_date = this.end_date;
    const loan_id = this.loan_id;
    this.loading = true;
    this.operationsService
      .saveABGL(this.currentUser.token, this.loan_id, this.assets_balance_gl, this.loan_product_id)
      .subscribe(res => {
      this.loading = false;
        this.showSuccess('Request successful')
      }, () => {
        this.loading = false;
        this.showError('An error occurred, try again');
      });
  }
  // doledger() {
  //   this.operationsService.post(this.loan_id)
  //     .subscribe(result => {
  //       this.loading = false;
         
  //     });
  // }
  updateT(acc){
    this.operationsService
      .updateChartTrans(this.currentUser.token, acc)
      .subscribe(res => { 
      }, () => { 
      });
  }
  updateTh(acc){
    this.operationsService
      .updateChartTrans(this.currentUser.token, acc)
      .subscribe(res => { 
      }, () => { 
      });
  }
  downloadJournalReports(){
    const start_date = this.start_date;
    const end_date = this.end_date;
    const loan_id = this.loan_id;
    this.loading = true;
    this.operationsService
      .downloadJournalReports(this.currentUser.token, start_date, end_date, loan_id)
      .subscribe(res => {
      this.loading = false;
      alert('Data Successfully exported. Download would start automatically.');
      window.open(res.message);
      }, () => {
        this.loading = false;
        this.showError('An error occurred, try again');
      });
  }
}
